import ContentRouter from "./ContentRouter";

export default ContentRouter;
